import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, restaurantSession } from "@/lib/api";
import { RestaurantLayout } from "@/components/tabdine/RestaurantLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function RestaurantSettings() {
  const [f, setF] = useState(null);
  const [hh, setHh] = useState(null);

  useEffect(() => {
    api.get("/restaurant/me").then((r) => setF(r.data));
    api.get("/restaurant/happy-hours").then((r) => setHh(r.data[0] || {
      start_time: "16:00", end_time: "18:00",
      days_of_week: [1, 2, 3, 4, 5], discount_percent: 20,
      item_ids: [], is_active: true,
    }));
  }, []);

  const save = async () => {
    const res = await api.patch("/restaurant/settings", f);
    restaurantSession.set(localStorage.getItem("tabdine_restaurant_session"), res.data);
    toast.success("Saved");
  };
  const saveHh = async () => {
    await api.post("/restaurant/happy-hours", hh);
    toast.success("Happy Hours updated");
  };

  if (!f) return <RestaurantLayout><div className="p-6">Loading…</div></RestaurantLayout>;

  return (
    <RestaurantLayout>
      <div className="p-4 lg:p-8 max-w-3xl">
        <h1 className="font-heading text-2xl font-bold text-brand-dark mb-4">Settings</h1>

        <section className="bg-white rounded-xl border border-brand-dark/5 p-4 mb-4">
          <div className="font-heading font-semibold mb-3">Profile</div>
          <div className="space-y-3 text-sm">
            <div>
              <label className="text-xs text-brand-dark/60">Restaurant name</label>
              <Input value={f.name || ""} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="s-name" />
            </div>
            <div>
              <label className="text-xs text-brand-dark/60">Description</label>
              <Input value={f.description || ""} onChange={(e) => setF({ ...f, description: e.target.value })} />
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="text-xs text-brand-dark/60">City</label>
                <Input value={f.city || ""} onChange={(e) => setF({ ...f, city: e.target.value })} />
              </div>
              <div>
                <label className="text-xs text-brand-dark/60">Address</label>
                <Input value={f.address || ""} onChange={(e) => setF({ ...f, address: e.target.value })} />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="text-xs text-brand-dark/60">Opening time</label>
                <Input value={f.opening_time || ""} onChange={(e) => setF({ ...f, opening_time: e.target.value })} />
              </div>
              <div>
                <label className="text-xs text-brand-dark/60">Closing time</label>
                <Input value={f.closing_time || ""} onChange={(e) => setF({ ...f, closing_time: e.target.value })} />
              </div>
            </div>
            <label className="flex items-center gap-2">
              <input type="checkbox" checked={!!f.is_closed_today} onChange={(e) => setF({ ...f, is_closed_today: e.target.checked })} /> Closed today
            </label>
            <div>
              <label className="text-xs text-brand-dark/60">Google Review URL (for 4–5★ redirect)</label>
              <Input value={f.google_review_url || ""} onChange={(e) => setF({ ...f, google_review_url: e.target.value })} />
            </div>
            <div>
              <label className="text-xs text-brand-dark/60">GSTIN</label>
              <Input value={f.gst_number || ""} onChange={(e) => setF({ ...f, gst_number: e.target.value })} />
            </div>
            <Button onClick={save} className="bg-brand-orange text-white" data-testid="save-settings">Save profile</Button>
          </div>
        </section>

        <section className="bg-white rounded-xl border border-brand-dark/5 p-4">
          <div className="font-heading font-semibold mb-3">Happy Hours</div>
          {hh && (
            <div className="space-y-3 text-sm">
              <label className="flex items-center gap-2">
                <input type="checkbox" checked={hh.is_active} onChange={(e) => setHh({ ...hh, is_active: e.target.checked })} /> Active
              </label>
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className="text-xs text-brand-dark/60">Start</label>
                  <Input value={hh.start_time} onChange={(e) => setHh({ ...hh, start_time: e.target.value })} placeholder="16:00" />
                </div>
                <div>
                  <label className="text-xs text-brand-dark/60">End</label>
                  <Input value={hh.end_time} onChange={(e) => setHh({ ...hh, end_time: e.target.value })} placeholder="18:00" />
                </div>
              </div>
              <div>
                <label className="text-xs text-brand-dark/60">Discount %</label>
                <Input type="number" value={hh.discount_percent} onChange={(e) => setHh({ ...hh, discount_percent: +e.target.value })} />
              </div>
              <Button onClick={saveHh} className="bg-brand-orange text-white" data-testid="save-hh">Save Happy Hours</Button>
            </div>
          )}
        </section>

        <section className="bg-white rounded-xl border border-brand-dark/5 p-4 mt-4" data-testid="support-section">
          <div className="font-heading font-semibold mb-2">Need help?</div>
          <p className="text-sm text-brand-dark/60 mb-3">
            Our team is here for setup questions, integrations, and anything you'd like to see next.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="mailto:support.tabdine@gmail.com?subject=Tabdine%20Support%20Request&body=Hi%20Tabdine%20team%2C%0A%0A"
              className="inline-flex items-center gap-2 bg-brand-orange text-white px-4 py-2 rounded-full text-sm hover:bg-brand-orange-dark"
              data-testid="contact-support-btn"
            >
              Contact Support
            </a>
            <div className="text-sm text-brand-dark/70">
              or email <span className="font-mono">support.tabdine@gmail.com</span>
            </div>
          </div>
        </section>
      </div>
    </RestaurantLayout>
  );
}
